<script>
  import { nextTick } from 'vue';

  import { CLOUDINARY_URL } from '@/constants';

  export default {
    name: 'll-image',

    props: {
      url: {
        type: String,
        required: true,
      },
      crop: {
        type: Object,
        validator: (data) =>
          Number.isInteger(data.x) &&
          Number.isInteger(data.y) &&
          Number.isInteger(data.width) &&
          Number.isInteger(data.height),
        required: false,
        default: null,
      },
      alt: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        isBlob: false,
        internalUrl: this.url,
      };
    },

    mounted() {
      this.isBlob = this.url.includes('blob:');

      nextTick(() => {
        if (this.isBlob) {
          const img = new Image();

          img.src = this.url;

          img.onload = () => {
            const canvas = this.$refs.imageCanvas;
            const c = this.crop;

            if (canvas) {
              const ctx = canvas.getContext('2d');

              if (c) {
                canvas.height = c.height;
                canvas.width = c.width;

                ctx.drawImage(
                  img,
                  c.x,
                  c.y,
                  c.width,
                  c.height, // copy
                  0,
                  0,
                  c.width,
                  c.height, // paste
                );
              } else {
                // Set the canvas to the image width/height
                canvas.height = img.naturalHeight;
                canvas.width = img.naturalWidth;
                ctx.drawImage(img, 0, 0);
              }
            }
          };
        } else if (!this.isBlob && this.crop) {
          // If the URL isn't a blob, use Cloudinary to generate the cropped image
          this.internalUrl = `${CLOUDINARY_URL}x_${this.crop.x},y_${this.crop.y},w_${this.crop.width},h_${this.crop.height},c_crop/${this.url}`;
        }
      });
    },
  };
</script>

<template>
  <canvas v-if="isBlob" ref="imageCanvas" @dragstart.prevent></canvas>
  <img v-else :src="internalUrl" :alt="alt" draggable="false" @dragstart.prevent />
</template>
